<template>
  <div :style="`background-color:${competTheme}`">
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      class="el-menu-vertical-demo"
      :background-color="competTheme"
      text-color="#fff"
      active-text-color="#ffe200"
    >
      <div class="menu_item" v-for="item in MENU_LIST" :key="item.id">
        <el-submenu v-if="item.children && item.children.length" :index="item.id">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item
            v-for="child in item.children"
            :key="child.id"
            :index="child.id"
            @click="handleChangeMenu(child)"
            >{{ child.name }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="item.id" @click="handleChangeMenu(item)">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { MENU_LIST } from '@/constants/common'

export default {
  name: 'HelloWorld',
  props: {},
  data() {
    return {
      MENU_LIST,
      list: [],
      activeIndex: '1'
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.path == '/') {
          this.activeIndex = '1'
          return
        }
        let code = to.path.split('/')[1]
        let num = this.MENU_LIST.findIndex((n) => n.code === code)
        if (num !== -1) {
          this.activeIndex = this.MENU_LIST[num].id
        } else {
          this.activeIndex = '10'
        }
      }
    }
  },
  methods: {
    handleChangeMenu(val) {
      this.$router.push({
        path: val.path
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  display: flex;
  .menu_item {
    flex: 1;
    text-align: center;
  }
  .el-menu-item i {
    color: #fff !important;
  }
  .el-menu-item.is-active i {
    color: #ffe200 !important;
  }
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: rgb(255, 255, 255, 0.2) !important;
}
.el-menu-item,
.el-submenu__title {
  font-size: 16px;
  font-weight: 600;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-submenu .el-menu {
  overflow: hidden;
}
.el-submenu .el-menu-item {
  padding-right: 0;
  overflow: hidden;
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/nav.vue